export default "__VITE_ASSET__C5K00Kn0__"